import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M961,1 C431.644706,1 1,431.644706 1,961 C1,1490.35529 431.644706,1921 961,1921 C1490.35529,1921 1921,1490.35529 1921,961 C1921,431.644706 1490.35529,1 961,1 M961,1808.05882 C493.875294,1808.05882 113.941176,1428.12471 113.941176,961 C113.941176,493.875294 493.875294,113.941176 961,113.941176 C1428.12471,113.941176 1808.05882,493.875294 1808.05882,961 C1808.05882,1428.12471 1428.12471,1808.05882 961,1808.05882 M1280.46541,561.685176 L960.954824,881.195765 L641.557176,561.685176 L561.707765,641.534588 L881.105412,961.045176 L561.707765,1280.44282 L641.557176,1360.29224 L960.954824,1040.89459 L1280.46541,1360.29224 L1360.31482,1280.44282 L1040.80424,961.045176 L1360.31482,641.534588 L1280.46541,561.685176 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTroubleLine = /*#__PURE__*/function (_Component) {
  _inherits(IconTroubleLine, _Component);

  var _super = _createSuper(IconTroubleLine);

  function IconTroubleLine() {
    _classCallCheck(this, IconTroubleLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconTroubleLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTrouble",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTroubleLine.displayName = "IconTroubleLine";
  return IconTroubleLine;
}(Component);

IconTroubleLine.glyphName = 'trouble';
IconTroubleLine.variant = 'Line';
IconTroubleLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTroubleLine;
export { IconTroubleLine };